export enum  AccessibleNavigationOption {
    LEFT= 'ArrowLeft',
    RIGHT= 'ArrowRight',
    TAB = 'Tab'
}
